import { ReactNode } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./constants";
import { InvoiceArrivalItemFormValues } from "./types";

interface Props {
  children?: ReactNode;
  defaultFormValues?: Partial<InvoiceArrivalItemFormValues>;
}

export const InvoiceArrivalItemFormProvider = ({
  children,
  defaultFormValues = {},
}: Props) => {
  const methods = useForm<InvoiceArrivalItemFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: defaultFormValues,
    resolver: yupResolver(schema),
  });

  const fieldsToRegister: (keyof InvoiceArrivalItemFormValues)[] = [
    "tradeMarkup",
    "webMarkup",
    "retailMarkup",
    "retailPrice",
    "tradePrice",
    "webPrice",
    "name",
  ];

  fieldsToRegister.forEach((t) => methods.register(t));

  return <FormProvider {...methods}>{children}</FormProvider>;
};
